import ViewCoupons from "./page/ViewCoupons";


const Coupon:React.FC = () =>{
    return(
        <div className="h-full overflow-hidden">
        <ViewCoupons/>
        </div>
    )
}
export default Coupon;